export default __webpack_public_path__ + "static/media/patient-forms.5f6d4c46.pdf";